module.exports = __webpack_public_path__ + "static/media/6.dc154294.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/6.mp3
// module id = 85
// module chunks = 0